export default __webpack_public_path__ + "static/media/gregory.60ba3d41.gif";